import { Box, Container, Paper, Stack, Typography } from "@mui/material";

const SampleCost = () => {
  return (
    <Box
      component="section"
      sx={{
        py: { xs: 4, md: 4 },
        backgroundColor: "var(--color-arctic)",
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, md: 4 },
            borderRadius: 2,
            background:
              "linear-gradient(180deg, #FFFFFF 0%, rgba(246,247,235,0.85) 100%)",
            border: "1px solid var(--color-midnight-15)",
            position: "relative",

            "&::before": {
              content: '""',
              position: "absolute",
              inset: 0,
              borderRadius: "inherit",
              boxShadow: "inset 4px 0 0 rgba(233,79,55,0.35)",
              pointerEvents: "none",
            },
          }}
        >
          <Typography
            component="h2"
            sx={{
              fontSize: { xs: "1.2rem", md: "1.6rem" },
              fontWeight: 800,
              mb: 1,
            }}
          >
            Sample Project Cost Ranges
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "0.85rem", md: "0.95rem" },
              color: "var(--color-midnight-70)",
              mb: 3,
            }}
          >
            Indicative development cost ranges based on real projects and
            delivery benchmarks.
          </Typography>

          <Stack spacing={1.5}>
            {[
              ["Landing Website", "₹25,000 – ₹80,000"],
              ["Business Website", "₹80,000 – ₹2,50,000"],
              ["Mobile App (MVP)", "₹3,00,000 – ₹8,00,000"],
              ["SaaS Platform", "₹6,00,000 – ₹20,00,000+"],
              ["Enterprise System", "Custom pricing"],
            ].map(([label, price]) => (
              <Stack
                key={label}
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  py: 1.2,
                  borderBottom: "1px dashed var(--color-midnight-15)",
                  "&:last-child": { borderBottom: "none" },
                }}
              >
                <Typography
                  sx={{ fontSize: { xs: "0.85rem", md: "0.95rem" } }}
                  fontWeight={600}
                >
                  {label}
                </Typography>
                <Typography
                  sx={{ fontSize: { xs: "0.85rem", md: "0.95rem" } }}
                  fontWeight={700}
                  color="var(--color-fiery)"
                >
                  {price}
                </Typography>
              </Stack>
            ))}
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

export default SampleCost;
